import { Pencil } from "lucide-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ModalCreateLocalPost } from "../../../components/FacilityDetailsComponents/ModalCreateLocalPost";
import { LocationData } from "../../../models/LocationData";

interface ICreateLocalPostButtonProps {
  locationData: LocationData;
}

export const CreateLocalPostButton = ({
  locationData,
}: ICreateLocalPostButtonProps) => {
  const [showModal, setShowModal] = useState(false);

  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`localPostsPage.${key}`);

  return (
    <>
      <button
        className="btn btn-blue btn-new-post"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <Pencil size={16} color="white" className="pencil-icon" />
        {t("new_post")}
      </button>
      {showModal && (
        <ModalCreateLocalPost
          locationData={locationData}
          locationId={locationData.id.toString()}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};
